/* eslint-disable */

import axios from 'axios';
import { getGemHost } from '@platform/shared';

const DOCS_HOST = (function () {
    return getGemHost('documentation');
})();

const mergeOptions = (options) => {
  options = {
    crossdomain: true,
    baseURL: `https://${DOCS_HOST}/api/`,
    withCredentials: true,
    ...options,
  };
  return options;
};

const transform = (response) => {
  const { error, errors } = response.data;

  if (error) {
    if (_.isObject(error) && Object.keys(error).length) {
      if (response.data.error.errorCode) {
        return Promise.reject({
          code: response.data.error.errorCode,
          message: response.data.error.errorMessage,
        });
      }

      return Promise.reject(response.data.error);
    }

    if (Object.keys(error).length) {
      return Promise.reject(error);
    }
  }

  if (errors && Object.keys(errors).length) {
    return Promise.reject(errors);
  }

  return response.data;
};

const parseError = (err) => {
  console.error('Request error: ', JSON.stringify(err));

  throw err;
};

const flatParams = (obj) => {
  const parseObject = (obj, path = []) => {
    let flattened = {};

    Object.keys(obj).forEach(key => {
      const curPath = path.length ? [...path, `[${key}]`] : [key];

      if (obj[key] && typeof obj[key] === 'object') {
        flattened = {
          ...flattened,
          ...parseObject(obj[key], curPath),
        };
      } else {
        flattened[curPath.join('')] = obj[key];
      }
    });

    return flattened;
  };

  return parseObject(obj);
};

export default {
  get(url, options = {}) {
    if (options.params) {
      options.params = flatParams(options.params);
    }

    return axios.get(url, mergeOptions(options)).then(transform).catch(parseError);
  },
  post(url, data = {}, options = {}) {
    return axios.post(url, data, mergeOptions(options)).then(transform).catch(parseError);
  },

  uploadFile(formData, progressHandler) {
    return this
      .post('/file/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        onUploadProgress(progressEvent) {
          let percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);

          if (progressHandler) {
            progressHandler(percent);
          }

          return percent;
        },
      });
  },
};
